import { classes, st } from './DraggableContainer.st.css.js';
import { useContext } from 'react';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';
export function useDraggableContainer(props) {
    const { draggable, dragging, dragDisabled, dim, highlight } = props;
    const { newColorsBranding } = useContext(WixStyleReactContext);
    return {
        className: st(classes.root, {
            newColorsBranding,
            draggable,
            dragging,
            dragDisabled,
            dim,
            highlight,
        }),
    };
}
//# sourceMappingURL=useDraggableContainer.js.map